import React from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Table, Badge } from "react-bootstrap";
import moment from "moment";

// Helper function to get the display name from assignment data
const getAssignedUserInfo = (assignment) => {
  // If assignedTo is an object with fullName (from the API response)
  if (assignment.assignedTo && typeof assignment.assignedTo === "object") {
    return {
      name: assignment.assignedTo.fullName,
      email: assignment.assignedTo.email,
      mobile: assignment.assignedTo.mobile,
      designation: assignment.assignedTo.designation,
    };
  }
  // Fallback for other cases
  return {
    name: assignment.assignedToName || "Unknown User",
    email: "",
    mobile: "",
    designation: "",
  };
};

const AssignmentHistoryModal = ({ show, onHide, history }) => {
  const navigate = useNavigate();

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton className="bg-light">
        <Modal.Title className="h5 mb-0">
          <i className="mdi mdi-history me-2"></i>
          Assignment History
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        {history.length > 0 ? (
          <div className="table-responsive">
            <Table hover className="mb-0">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Assignment Details</th>
                  <th>Assigned At</th>
                  <th>Status</th>
                  <th>Position</th>
                </tr>
              </thead>
              <tbody>
                {history.map((item, index) => (
                  <tr key={item._id}>
                    <td className="text-muted">{index + 1}</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <div className="avatar-xs me-2">
                          <div className="avatar-title rounded-circle bg-light text-primary">
                            {item.assignedToModel?.charAt(0) || "U"}
                          </div>
                        </div>
                        <div>
                          <div className="fw-medium">
                            {item.assignedToModel === "User"
                              ? "Agent"
                              : item.assignedToModel}
                            :{" "}
                            <button
                              type="button"
                              className="btn btn-link p-0 align-baseline text-primary text-decoration-underline"
                              onClick={() => {
                                const assignedUser = item.assignedTo || {};
                                const userId = assignedUser._id;
                                const userName = getAssignedUserInfo(item).name;
                                if (userId) {
                                  navigate(`/user-followup-leads/${userId}`, {
                                    state: { userName },
                                  });
                                }
                              }}
                            >
                              {getAssignedUserInfo(item).name}
                            </button>
                            {getAssignedUserInfo(item).designation && (
                              <Badge bg="info" className="ms-2">
                                {getAssignedUserInfo(item).designation}
                              </Badge>
                            )}
                          </div>
                          <div className="text-muted small">
                            {getAssignedUserInfo(item).mobile && (
                              <span className="me-2">
                                <i className="mdi mdi-phone me-1"></i>
                                {getAssignedUserInfo(item).mobile}
                              </span>
                            )}
                            {getAssignedUserInfo(item).email && (
                              <div
                                className="text-truncate"
                                style={{ maxWidth: "200px" }}
                              >
                                <i className="mdi mdi-email-outline me-1"></i>
                                {getAssignedUserInfo(item).email}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      {moment(item.assignedAt).format("DD MMM YYYY, hh:mm A")}
                    </td>
                    <td>
                      <Badge
                        bg={
                          index === history.length - 1 ? "success" : "secondary"
                        }
                        className="badge-soft"
                      >
                        {index === history.length - 1 ? "Current" : "Previous"}
                      </Badge>
                    </td>
                    <td>
                      <Badge bg="info">{item.assignPosition || "N/A"}</Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <div className="text-center py-5">
            <div className="avatar-md mx-auto mb-3">
              <div className="avatar-title bg-light text-secondary rounded-circle">
                <i className="mdi mdi-history fs-24"></i>
              </div>
            </div>
            <h5>No Assignment History</h5>
            <p className="text-muted">
              This inquiry has not been assigned to anyone yet.
            </p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="border-top">
        <button type="button" className="btn btn-light" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssignmentHistoryModal;
